import React from "react";
import styles from "./WorksBody.module.css";

import FlowGraph from "../../../../assets/Images/TsundokuAdminStudio/FlowGraph.webp";

const WorksBody = () => {
  return (
    <div className={styles.entireWorksBody}>
      <div className={styles.worksBodyContainer}>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ✨ Key Features
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Replaced type: image with type: file for body media to support
                WebP and MP4 formats, enabling 90%+ file size reductions and
                faster mobile loading.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Structured content types for articles and other types of media
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Live content draft previews directly within the studio
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                UI enhancements like field grouping, conditional field
                visibility, and inline validation
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Role-based access control with environment-based preview logic
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Integrated image CDN and dynamic OG card generation (WIP)
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            👥 Editor Experience Optimization
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Added a built-in preview window for real-time feedback without
                tab-switching
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Grouped related fields and included helpful error messaging
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Prioritized ease-of-use for non-technical collaborators
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ⚙️ Implementation Details
          </h2>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Custom Studio Configuration
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Reusable schema definitions with inline help, fieldsets, and
                validation
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Modular content types structured for future expansion (e.g.,
                series, features)
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Live Preview & Draft Mode Handling
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Integrated{" "}
                <a href="https://www.npmjs.com/package/sanity-plugin-iframe-pane?activeTab=readme">
                  @sanity/image-url{" "}
                </a>{" "}
                for in-studio previews
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Built cookie-based session logic to toggle preview mode via
                Next.js API routes
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Restricted previews to dev and authorized environments only
              </span>
            </p>
          </div>
        </div>
        <img src={FlowGraph} className={styles.worksBodyDesignImage1} />
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Image & Metadata Delivery
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Used Sanity CDN +{" "}
                <a href="https://www.npmjs.com/package/sanity-plugin-iframe-pane?activeTab=readme">
                  @sanity/image-url{" "}
                </a>
                for responsive asset optimization
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Implemented OGP image generation with{" "}
                <a href="https://www.npmjs.com/package/@vercel/og">
                  @vercel/og{" "}
                </a>
                for social sharing (WIP)
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Authentication & Access Control
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>Secured studio access with Google OAuth + 2FA</span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Scoped roles and tokens to protect sensitive content and APIs
              </span>
            </p>
          </div>
        </div>

        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🔐 Security + Performance Highlights
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Preview Access:</b> Session-based SSR for preview protection
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Environment Checks:</b> Environment guards to prevent
                accidental draft leaks
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Image Performance:</b> Dynamic image delivery tuned for
                layout context
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Token Security:</b> Public GROQ queries scoped with
                server-only tokens
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🧠 Problem Solving
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Early in development, I discovered edge cases where preview
                content could unintentionally appear in production. I resolved
                this by restructuring how draft mode was activated—using cookies
                and route checks to isolate it to preview-only contexts. The
                result is a safe, predictable editorial experience with zero
                risk of draft exposure.
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>💡 What I Learned</h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Sanity Studio is a developer-friendly CMS—but getting preview
                mode and session security right takes intention and iteration.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                UI ergonomics for editors matter just as much as schema
                design—field grouping and real-time feedback changed how
                contributors interacted with content.
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            📈 Why This Matters
          </h2>
          <p className={styles.worksBodyKeyPointsDetail}>
            The Tsundoku Admin Studio reflects the kind of developer-built
            tooling that empowers real teams. It:
          </p>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Enables non-technical users to manage content confidently
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Eliminates friction by providing live, in-studio previewing
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Maintains security across sessions, environments, and API layers
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Shows my ability to design and integrate full-stack systems that
                are usable, scalable, and secure
              </span>
            </p>
          </div>
          <p className={styles.worksBodyKeyPointsDetail}>
            It’s more than a CMS—it's a custom editorial workspace built with
            long-term maintainability and real-world publishing needs in mind.
          </p>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>📝 Learn More</h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Want to dive deeper into the concepts behind this build?
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Read an article of mine that touches on{" "}
                <a href="https://www.tsundoku.blog/posts/from-curious-to-coding-building-a-blog-with-next-js-sanity-typescript-and-tailwind">
                  Traditional vs Headless CMS
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.14645 10.6464C2.95118 10.8417 2.95118 11.1583 3.14645 11.3536C3.34171 11.5488 3.65829 11.5488 3.85355 11.3536L3.14645 10.6464ZM12 3C12 2.72386 11.7761 2.5 11.5 2.5L7 2.5C6.72386 2.5 6.5 2.72386 6.5 3C6.5 3.27614 6.72386 3.5 7 3.5L11 3.5L11 7.5C11 7.77614 11.2239 8 11.5 8C11.7761 8 12 7.77614 12 7.5L12 3ZM3.85355 11.3536L11.8536 3.35355L11.1464 2.64645L3.14645 10.6464L3.85355 11.3536Z"
                      fill="green"
                    />
                  </svg>{" "}
                </a>
                for a breakdown of how modern content systems work
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Or maybe explore Sanity CMS in depth where I explain{" "}
                <a href="https://www.tsundoku.blog/posts/content-management-with-sanity-from-a-studio-to-a-nice-studio">
                  how I built and customized this studio
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.14645 10.6464C2.95118 10.8417 2.95118 11.1583 3.14645 11.3536C3.34171 11.5488 3.65829 11.5488 3.85355 11.3536L3.14645 10.6464ZM12 3C12 2.72386 11.7761 2.5 11.5 2.5L7 2.5C6.72386 2.5 6.5 2.72386 6.5 3C6.5 3.27614 6.72386 3.5 7 3.5L11 3.5L11 7.5C11 7.77614 11.2239 8 11.5 8C11.7761 8 12 7.77614 12 7.5L12 3ZM3.85355 11.3536L11.8536 3.35355L11.1464 2.64645L3.14645 10.6464L3.85355 11.3536Z"
                      fill="green"
                    />
                  </svg>
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorksBody;
